import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_DIRECCIONES = 'ALL_DIRECCIONES';
export const LOADING_ALL_DIRECCIONES = 'LOADING_ALL_DIRECCIONES';
export const ACTIVO_DIRECCIONES = 'ACTIVO_DIRECCIONES';
export const PARAMS_DIRECCIONES = 'PARAMS_DIRECCIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const direccionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_DIRECCIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_DIRECCIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_DIRECCIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_DIRECCIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
